import { Pipe, PipeTransform } from '@angular/core';
import * as jalaali from 'jalaali-js';

@Pipe({
  name: 'shamsiDate'
})
export class ShamsiDatePipe implements PipeTransform {
  // transform(value: string | Date): string {
  //   if (!value) return '';
  //   const date = new Date(value);
  //   const jDate = jalaali.toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate());
  //   return `${jDate.jy}/${jDate.jm}/${jDate.jd}`;
  // }

  transform(value: string | Date): string {
    if (!value) return '';
    const date = new Date(value);
    const jDate = jalaali.toJalaali(date.getFullYear(), date.getMonth() + 1, date.getDate());
    const jy = jDate.jy;
    const jm = jDate.jm.toString().padStart(2, '0');
    const jd = jDate.jd.toString().padStart(2, '0');
    return `${jy}/${jm}/${jd}`;
  }
  
}
